import TranslationsConfigType from './translationType';

const nbTranslations: TranslationsConfigType = {
    modal: {
        header: 'Bruk av informasjonskapsler (Cookies)',
        subHeader:
            'Vi bruker informasjonskapsler (cookies) på bankens nettsider. Dette er små tekstfiler som lagres i nettleseren din. Disse brukes for flere formål, som å sørge for at nettsidene fungerer, sikkerhet, huske innstillinger og valg, samt å måle hvordan annonser fungerer. Noen er nødvendige for grunnleggende funksjoner, mens andre brukes kun hvis du gir samtykke. Du kan når som helst endre eller trekke tilbake samtykket ditt. Les mer i personvernerklæringen vår.',
        acceptAll: 'Godta alle',
        onlyNecessary: 'Kun nødvendige',
    },
    success: {
        header: 'Lagret',
        firstTimeSaveDescription: 'Valgene dine ble lagret',
        description: 'Endringene dine ble lagret',
        timeout: 1000,
    },
    cookies: {
        technical: {
            header: 'Strengt nødvendige cookies',
            description:
                'Disse informasjonskapslene er nødvendige for at nettsiden skal fungere som den skal, for eksempel for sikkerhet og grunnleggende funksjoner. De kan ikke deaktiveres.',
            cookieName: 'eika_consent_set',
            isDisabled: true,
        },
        marketing: {
            header: 'Markedsføring',
            description:
                'Vi bruker dataen din for å måle hvor godt våre kampanjer fungerer. Dette hjelper oss å forstå hvilke annonser som gir resultater, slik at vi kan forbedre markedsføringen vår. Vi bruker ikke dataen til å vise deg personlig tilpassede annonser eller til retargeting.',
            cookieName: 'eika_consent_marketing',
        },
    },
};

export default nbTranslations;
